/* The Band — What's in the box: items start piled in the middle and spread into a row (scrubbed). */
(function () {
  function syncColour(root, c) {
    if (!c) return;
    root.querySelectorAll('[data-band-stack] img').forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-key') === c.key); });
  }

  function init(root) {
    if (!root || root._bdBox) return;
    root._bdBox = true;
    var D = window.Dozzee;
    syncColour(root, D.getColour());
    var onC = function (e) { if (document.body.contains(root)) syncColour(root, e.detail && e.detail.colour); else document.removeEventListener('dozzee:colour', onC); };
    document.addEventListener('dozzee:colour', onC);

    if (D.reduce) { root.classList.add('is-static'); return; }

    D.gsap(function (gsap) {
      if (!document.body.contains(root)) return;
      var q = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
      var rtl = D.settings && D.settings.rtl ? -1 : 1;
      root._bdCtx = gsap.context(function () {
        var bWrap = root.querySelector('[data-box-wrap]');
        if (!bWrap) return;
        var ox = function (el) { return (el.offsetParent ? el.offsetParent.clientWidth : 0) / 2 - (el.offsetLeft + el.offsetWidth / 2); };
        var oy = function (el) { return (el.offsetParent ? el.offsetParent.clientHeight : 0) / 2 - (el.offsetTop + el.offsetHeight / 2); };
        var stats = q('[data-box-stat]').filter(function (el) { return el.offsetParent !== null; });
        var tl = gsap.timeline({ scrollTrigger: { trigger: bWrap, start: 'top 70%', end: 'bottom bottom', scrub: 0.7, invalidateOnRefresh: true } })
          .from(q('[data-box-item]'), {
            x: function (i, el) { return ox(el); },
            y: function (i, el) { return oy(el); },
            rotation: function (i) { return [-14, 10, -6, 15][i % 4] * rtl; },
            scale: 0.84, duration: 1, ease: 'power2.inOut', stagger: 0.05
          }, 0)
          .from(q('[data-box-label]'), { autoAlpha: 0, y: 10, stagger: 0.05, duration: 0.25 }, 0.85);
        if (stats.length) tl.from(stats, { autoAlpha: 0, y: 26, stagger: 0.07, duration: 0.3 }, 1.05);
        tl.to({}, { duration: 0.35 });
      }, root);
    });
  }

  function boot(scope) {
    if (!window.Dozzee || !window.Dozzee.getColour) return setTimeout(function () { boot(scope); }, 50);
    (scope || document).querySelectorAll('[data-section-type="band-box"]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-section-type="band-box"]');
    if (r && r._bdCtx) r._bdCtx.revert();
  });
})();
